import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AiOutlineKey, AiOutlineMail } from 'react-icons/ai';
import ReCAPTCHA from 'react-google-recaptcha';

const EmailVerification = () => {
  const [email, setEmail] = useState('');
  const [otp, setOTP] = useState('');
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch('https://cloudapi.emedhatechnologies.com/auth/api/verify-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, otp }),
      });

      const data = await response.json();

      if (response.ok) {
        setVerified(true);
        alert('Email verified successfully!');
        navigate('/');
      } else {
        setError(data.error || 'Verification failed. Please try again.');
      }
    } catch (error) {
      setError('Verification failed. Please try again.');
    }
  };

  const containerStyle = {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f2f2f2',
    fontFamily: '"Courier New", Courier, monospace',
    padding: '20px',
  };

  const formWrapper = {
    backgroundColor: '#fff',
    padding: '40px',
    border: '1px solid #ccc',
    width: '100%',
    maxWidth: '400px',
    fontSize: '12px',
    color: '#333',
    boxSizing: 'border-box',
  };

  const inputWrapper = {
    position: 'relative',
    marginBottom: '15px',
  };

  const iconStyle = {
    position: 'absolute',
    top: '50%',
    left: '10px',
    transform: 'translateY(-50%)',
    color: '#666',
    fontSize: '16px',
  };

  const inputStyle = {
    width: '100%',
    padding: '10px 10px 10px 35px',
    border: '1px solid #000',
    borderRadius: '0',
    fontSize: '12px',
    fontFamily: '"Courier New", Courier, monospace',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    width: '100%',
    padding: '10px',
    backgroundColor: '#07526f',
    color: '#fff',
    border: '1px solid #000',
    borderRadius: '0',
    fontSize: '12px',
    fontWeight: 'bold',
    cursor: 'pointer',
    fontFamily: '"Courier New", Courier, monospace',
  };

  const alertStyle = (type) => ({
    padding: '10px',
    backgroundColor: type === 'error' ? '#f8d7da' : '#d1e7dd',
    border: `1px solid ${type === 'error' ? '#f5c2c7' : '#badbcc'}`,
    color: type === 'error' ? '#842029' : '#0f5132',
    marginBottom: '15px',
    fontSize: '12px',
  });

  return (
    <div style={containerStyle}>
      <div style={formWrapper}>
        <h1 style={{ textAlign: 'center', fontSize: '24px', marginBottom: '20px' }}>
          <strong>Email Verification</strong>
        </h1>

        {!verified ? (
          <form onSubmit={handleSubmit} noValidate>
            {error && <div style={alertStyle('error')}>{error}</div>}

            <div style={inputWrapper}>
              <AiOutlineMail style={iconStyle} />
              <input
                type="email"
                placeholder="Enter your email"
                style={inputStyle}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div style={inputWrapper}>
              <AiOutlineKey style={iconStyle} />
              <input
                type="text"
                placeholder="Enter OTP"
                style={inputStyle}
                value={otp}
                onChange={(e) => setOTP(e.target.value)}
                required
              />
            </div>

            <div style={{ marginBottom: '15px' }}>
              <ReCAPTCHA sitekey="6LfB4CIqAAAAABTTABOif9nMWUiFuMfIp31_UU5I" />
            </div>

            <button type="submit" style={buttonStyle}>Verify</button>
          </form>
        ) : (
          <div style={alertStyle('success')}>Email verified successfully!</div>
        )}
      </div>
    </div>
  );
};

export default EmailVerification;
